import TagManager from 'react-gtm-module';
import { RUT_WITHOUT_DV } from './national-identifier';
import { formatYearMonthDay } from './date';
import dayjs from '../config/dayjs';

export const isGoogleTagManagerEnabled = () => (
  process.env.REACT_APP_ENV === 'production' && !!process.env.REACT_APP_GTM_ID
);

export const pushConversionEvent = ({ event, nationalIdentifier, countryName }) => {
  if (!isGoogleTagManagerEnabled()) return;
  const withoutDv = RUT_WITHOUT_DV[countryName];
  if (!withoutDv || !nationalIdentifier) return;
  TagManager.dataLayer({
    dataLayer: {
      event,
      transaction_id: `${event}_${withoutDv(nationalIdentifier)}_${formatYearMonthDay(dayjs())}`,
    },
  });
};

export const pushCompanyConversionEvent = (event, company) => pushConversionEvent({
  event,
  nationalIdentifier: company?.masterEntity?.displayNationalIdentifier,
  countryName: company?.masterEntity?.country?.name,
});
